<template>
    <div class="echarts-contain">
        <div :id="id" class="o-echarts"></div>
        <div class="legend-contain">
            <div class="legend-box">
                <div class="legend-title">线上企业:</div>
                <div class="box">
                    <div class="box-color color1"></div>
                    <div class="box-status">使用中</div>
                </div>
                <div class="box">
                    <div class="box-color color2"></div>
                    <div class="box-status">待激活</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import echarts from 'echarts';

    export default {
        name: 'columnCharts',
        props: {
            'columnData': Array,
            'xAxis': Array
        },
        data () {
            return {
                id: 'echarts_' + new Date().getTime() + Math.floor(Math.random() * 1000),
                echartObj: null,
                option: {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: { // 坐标轴指示器，坐标轴触发有效
                            type: 'line' // 默认为直线，可选为：'line' | 'shadow'
                        }
                    },
                    grid: {
                        left: '2%',
                        right: '2%',
                        top:'13%',
                        bottom: '8%',
                        containLabel: true
                    },
                    dataZoom: [
                        // 柱状图滚动
                        {
                            type: 'inside',
                            xAxisIndex: 0,
                            start: 0,
                            end: 40
                        },
                        // 滚动条滚动
                        // {
                        //     show: true,
                        //     xAxisIndex: 0,
                        //     type: 'slider',
                        //     top: '93%',
                        //     height: 16,
                        //     start: 20,
                        //     end: 60
                        // }
                    ],
                    yAxis: {
                        type: 'value',
                        splitNumber: 3,
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                            // 网格分割线样式
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: '#E9E9E9',
                                width: 0.5,
                                type: 'solid'
                            }
                        },
                        axisLabel: { // 调整左侧Y轴刻度， 直接按对应数据显示
                            show: true,
                            textStyle: {
                                color: '#999999'
                            },
                            showMinLabel: true,
                            showMaxLabel: true,
                            formatter: function (value) {
                                return value;
                            }
                        }
                    },
                    xAxis: {},
                    series: []
                }
            };
        },
        watch: {
            columnData: {
                handler (newValue, oldValue) {
                    for (let i = 0; i < newValue.length; i++) {
                        if (oldValue[i] !== newValue[i]) {
                            this.echartObj.setOption(this.setSeriesData(), true);
                        }
                    }
                },
                deep: true
            },
            xAxis: {
                handler (newValue, oldValue) {
                    for (let i = 0; i < newValue.length; i++) {
                        if (oldValue[i] !== newValue[i]) {
                            this.echartObj.setOption(this.setSeriesData(), true);
                        }
                    }
                },
                deep: true
            }
        },
        mounted () {
            this.echartObj = echarts.init(document.getElementById(this.id));
            this.echartObj.setOption(this.setSeriesData(), true);
        },
        methods: {
            getXaxisData () {
                // 填入横轴数据
                return this.xAxis
            },
            setSeriesData () {
                this.setOptions('xAxis', (() => {
                    return {
                        type: 'category',
                        axisTick: {
                            'show': false
                        },
                        axisLabel: {
                            interval: 0,
                            show: true,
                            margin: 15,
                            formatter: function (value, index) {
                                value = String(value)
                                if (value.length > 6) {
                                    return String(value).substring(0, 5) + '···';
                                }
                                return value;
                            },
                            textStyle: {
                                color: '#4A4A4A',
                                fontSize: 10,
                            }
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: '#E9E9E9',
                                width:0.5
                            }
                        },
                        data: this.getXaxisData()
                    }
                })());
                this.setOptions('series', (() => {
                    return this.columnData.map(item => {
                        return {
                            name: item.type,
                            type: 'bar',
                            stack: item.stack,
                            barWidth: 10, // 柱图宽度
                            data: item.data,
                            itemStyle: {
                                normal: {
                                    color: item.color
                                }
                            }
                        }
                    });
                })());
                return this.option;
            },
            setOptions (objKey, objVal) {
                if (this.option[objKey] && typeof this.option[objKey] === 'object' && !Array.isArray(this.option[objKey])) {
                    this.option[objKey] = Object.assign(this.option[objKey], objVal);
                } else {
                    this.option[objKey] = objVal;
                }
                this.$set(this.option, objKey, this.option[objKey]);
            }
        }
    }
</script>

<style lang="less" scoped>
.echarts-contain{
    width: 100%;
    height: 90%;
    .o-echarts {
        width: 100%;
        height: 100%;
    }
    .legend-contain{
        display: flex;
        margin-top: 10px;
        margin-bottom: 20px;
        width: 100%;
        padding: 0 10px;
        justify-content:center;
        .legend-box{
            display: flex;
            align-items: center;
            .legend-title{
                font-size: 10px;
                color: #999999;
                margin-right: 8px;
                font-weight:400;
            }
            .box{
                display: flex;
                align-items: center;
                margin-right: 8px;
                .box-color{
                    width: 7px;
                    height: 7px;
                    margin-right: 4px;
                }
                .color1{
                    background: rgba(54,179,116,1);
                }
                .color2{
                    background: rgba(54,179,116,0.4);
                }
                .color3{
                    background: rgba(255,140,25,1);
                }
                .color4{
                    background: rgba(255,140,25,0.4);
                }
                .box-status{
                    font-size:10px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:rgba(153,153,153,1);
                    line-height:10px;
                }
            }
        }
    }
}
</style>
